export default __webpack_public_path__ + "static/media/tick-icon.40a5e975.svg";